import { OPERAZIONI_BASE } from '../network/OperazioniBase'

async function elencoPromessaStandard(configElenco) {
  const {
    chiave,
    operationId = OPERAZIONI_BASE.DIZIONARIO_GET,
    inviaOperazione,
    dizionario,
    params = null,
    operationData: operationData_Config = null,
    operationOptions: operationOptions_Config = null,
    trasformaElenco: trasformaElenco_Config = data => data,
    operationDataExtra = null,
  } = configElenco

  let operationData
  let trasformaElenco
  const operationOptions = { ...operationOptions_Config }

  if (operationId === OPERAZIONI_BASE.DIZIONARIO_GET) {
    const nome = dizionario || chiave
    operationData = { nome, ...(params && { params }), ...operationDataExtra }
    trasformaElenco = data => trasformaElenco_Config(data[nome])
  } else {
    operationData = (operationData_Config || operationDataExtra) ? { ...operationData_Config, ...operationDataExtra } : null
    trasformaElenco = trasformaElenco_Config
  }

  const { ok, data, error } = await inviaOperazione(operationId, operationData, operationOptions)
  if (ok) return { ok: true, data: trasformaElenco(data) }
  return { ok: false, error: error.messaggi[0]?.msg }
}

async function elencoInizializzazionePromessaStandard(configElenco) {
  const {
    chiave,
    operationId = OPERAZIONI_BASE.DIZIONARIO_INIZIALIZZA,
    inviaOperazione,
    dizionario,
    params = null,
    operationData: operationData_Config = null,
    operationOptions: operationOptions_Config = null,
  } = configElenco

  let operationData
  const operationOptions = { ...operationOptions_Config }

  if (operationId === OPERAZIONI_BASE.DIZIONARIO_INIZIALIZZA) {
    const nome = dizionario || chiave
    operationData = { nome, ...(params && { params }) }
  } else {
    operationData = operationData_Config
  }

  const { ok, error } = await inviaOperazione(operationId, operationData, operationOptions)
  if (ok) return { ok: true }
  return { ok: false, error: error.messaggi[0]?.msg }
}

function elencoEntityTipologia(entity, opzioni = {}) {
  const {
    aggiungiOpzioneVuota = true
  } = opzioni

  return {
    dizionario: 'entityTipologia',
    params: { entity },
    trasformaElenco: tipologie => ([
      ...(aggiungiOpzioneVuota ? [{ value: '', label: '' }] : []),
      ...tipologie.map(({ id, nome, codice }) => ({
        value: String(id),
        label: nome,
        codice
      }))
    ]),
    legatoAlComando: true
  }
}

function elencoStatiCustom(entity) {
  return {
    dizionario: 'stato-custom',
    params: { entity },
    legatoAlComando: true
  }
}

function elencoStrumenti(tipo) {
  return {
    dizionario: 'strumenti',
    params: { ...(tipo && { tipo }), ancheNonAttivi: true },
    legatoAlComando: true
  }
}

function elencoVariabiliConNomi(nomi) {
  return {
    legatoAlComando: true,
    operationId: OPERAZIONI_BASE.VARIABILI_ELENCO,
    operationData: { nomi },
    trasformaElenco: ({ vars }) => vars.reduce(
      (accumulatoreVars, variabile) => ({
        ...accumulatoreVars,
        [variabile.nome]: variabile
      }),
      {}
    )
  }
}

const TIPI_VISURA = {
  // SOSTA: 'SOSTA', // Non serve sulla parte web
  CONTROLLO: 'CONTROLLO',
  VEICOLO_PROPRIETARI: 'VEICOLO_PROPRIETARI',
  DATI_PATENTE: 'DATI_PATENTE',
}

const LABEL_TIPI_VISURA = {
  // [TIPI_VISURA.SOSTA]: 'Controllo sosta',
  [TIPI_VISURA.CONTROLLO]: 'Visura semplice',
  [TIPI_VISURA.VEICOLO_PROPRIETARI]: 'Visura completa',
  [TIPI_VISURA.DATI_PATENTE]: 'Visura anagrafica'
}

const ENTI_VISURA_ANAGRAFICA = {
  MCTC: 'MCTC',
  ANPR: 'ANPR',
}

export {
  elencoPromessaStandard,
  elencoInizializzazionePromessaStandard,
  elencoEntityTipologia,
  elencoStatiCustom,
  elencoStrumenti,
  elencoVariabiliConNomi,
  TIPI_VISURA,
  LABEL_TIPI_VISURA,
  ENTI_VISURA_ANAGRAFICA,
}